import { c as _c } from "react/compiler-runtime";
import { DragDropContext, Droppable, type DroppableProvided, type DroppableStateSnapshot, type OnDragEndResponder } from "@hello-pangea/dnd";
import Add from "@mui/icons-material/Add";
import { CircularProgress, IconButton, Stack, type StackProps } from "@mui/material";
import React from "react";
import { SelectBarChipSkeleton } from "#/features/selectBar/ui/SelectBarChip";
type DraggableSelectBarListProps = Omit<StackProps, "children" | "onDragEnd"> & {
  isLoading?: boolean;
  isEmpty?: boolean;
  droppableId: string;
  onItemDragEnd: OnDragEndResponder;
  isEditable?: boolean;
  handleAddItem?: () => void;
  addItemTitle?: string;
  children(provided: DroppableProvided, snapshot: DroppableStateSnapshot): React.ReactNode | undefined;
};
export const DraggableSelectBarList: React.FC<DraggableSelectBarListProps> = t0 => {
  const $ = _c(25);
  let addItemTitle;
  let children;
  let droppableId;
  let handleAddItem;
  let isEditable;
  let isEmpty;
  let isLoading;
  let onItemDragEnd;
  let restProps;
  if ($[0] !== t0) {
    ({
      isLoading,
      isEmpty,
      droppableId,
      onItemDragEnd,
      isEditable,
      addItemTitle,
      handleAddItem,
      children,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = addItemTitle;
    $[2] = children;
    $[3] = droppableId;
    $[4] = handleAddItem;
    $[5] = isEditable;
    $[6] = isEmpty;
    $[7] = isLoading;
    $[8] = onItemDragEnd;
    $[9] = restProps;
  } else {
    addItemTitle = $[1];
    children = $[2];
    droppableId = $[3];
    handleAddItem = $[4];
    isEditable = $[5];
    isEmpty = $[6];
    isLoading = $[7];
    onItemDragEnd = $[8];
    restProps = $[9];
  }
  const t1 = !isEditable;
  let t2;
  if ($[10] !== addItemTitle || $[11] !== children || $[12] !== handleAddItem || $[13] !== isEditable || $[14] !== isEmpty || $[15] !== isLoading || $[16] !== restProps) {
    t2 = (provided, droppableSnapshot) => <Stack {...provided.droppableProps} ref={provided.innerRef} flexWrap="wrap" alignItems="center" direction="row" gap={1} {...restProps}>{isEmpty && <Stack direction="row" gap={1}><SelectBarChipSkeleton width={112} /><SelectBarChipSkeleton width={42} /><SelectBarChipSkeleton /><SelectBarChipSkeleton width={24} /></Stack>}{children(provided, droppableSnapshot)}{provided.placeholder}{isEditable && <IconButton title={addItemTitle} size="small" onClick={handleAddItem} disabled={isLoading} sx={{
        mt: 0.15
      }}>{isLoading ? <CircularProgress size="1.3rem" /> : <Add fontSize="small" />}</IconButton>}</Stack>;
    $[10] = addItemTitle;
    $[11] = children;
    $[12] = handleAddItem;
    $[13] = isEditable;
    $[14] = isEmpty;
    $[15] = isLoading;
    $[16] = restProps;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== droppableId || $[19] !== t1 || $[20] !== t2) {
    t3 = <Droppable droppableId={droppableId} direction="horizontal" isDropDisabled={t1} isCombineEnabled={false} ignoreContainerClipping={true}>{t2}</Droppable>;
    $[18] = droppableId;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== onItemDragEnd || $[23] !== t3) {
    t4 = <DragDropContext onDragEnd={onItemDragEnd}>{t3}</DragDropContext>;
    $[22] = onItemDragEnd;
    $[23] = t3;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  return t4;
};